import { Card, CardDescription, CardHeader, CardTitle } from '@saas-kit/ui';

interface Props {
  title: string;
  body: string;
  /**
   * Retained for call-site compatibility. The workspace-chooser screen this
   * used to link to was removed; the active tenant is now always resolved
   * before the app shell renders, so this fallback is purely defensive.
   */
  cta?: string;
}

/**
 * Graceful placeholder shown on a feature page if it ever renders without an
 * active tenant. With the RequireTenant guard in place this should not occur
 * in normal flow — it exists so a page degrades to a message instead of
 * crashing on missing tenant context.
 */
export function TenantRequiredState({ title, body }: Props): JSX.Element {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{body}</CardDescription>
      </CardHeader>
    </Card>
  );
}
